import { onSelectChange } from "@portal/BaseComponents/Select/type";
import { useUpdateDisputeStatus } from "@portal/queries/dispute-query";
import { disputeStatusOptions } from "@portal/store/Filters/dipsutes/predicate";
import { DisputeStatus } from "@portal/types/entities/dispute";
import { getDisputeStatusConfig } from "./predicate";
import { StyledDisputeStatus } from "./styles";
import { DisputeStatusSelectProps } from "./type";

function DisputeStatusSelect(props: DisputeStatusSelectProps) {
  const { value, onChange } = props;
  const handleUpdateDisputeStatus = useUpdateDisputeStatus();
  function handleChange(...args: onSelectChange<DisputeStatus>): void {
    onChange?.(...args);
    handleUpdateDisputeStatus.mutateAsync({ status: args[0] });
  }

  return (
    <StyledDisputeStatus
      defaultValue="OPEN"
      css={{ ...getDisputeStatusConfig(value) }}
      options={disputeStatusOptions}
      onChange={handleChange}
      value={value}
      loading={handleUpdateDisputeStatus.isLoading}
      popupMatchSelectWidth={false}
    />
  );
}

export { DisputeStatusSelect };
